import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import WorkRegistration from '@/components/work_regstration.vue'
import SelectButton from 'primevue/selectbutton'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
export default class extends Controller {
  static targets = ['calendar']
  connect() {
    const app = createApp(WorkRegistration, {
      creatorId: this.element.dataset.creatorId,
      currentUser: JSON.parse(this.element.dataset.currentUser),
      workPeriod: this.element.dataset.workPeriod
        ? JSON.parse(this.element.dataset.workPeriod)
        : {},
      shiftOptions: JSON.parse(this.element.dataset.shiftOptions),
      shiftTimeTypeId: Number(this.element.dataset.shiftTimeTypeId)
    })
    app.use(PrimeVue)
    app.component('SelectButton', SelectButton)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.calendarTarget)
  }
}
